<script>
import { parseEventTime, toDate } from "@/lib/date-utils"

export default {
  functional: true,

  props: {
    startsAt: { type: String, required: true },
    endsAt: { type: String, required: true },
    isAllDay: { type: Boolean, default: false }
  },

  render(h, { props }) {
    // TODO: take into account schedule spanning multiple days
    return (
      <span>
        {toDate(props.startsAt, "MMM D")}&nbsp;
        {props.isAllDay ? "-" : "at"}&nbsp;
        {parseEventTime(props.startsAt, props.endsAt, props.isAllDay, false)}
      </span>
    )
  }
}
</script>
